// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","774":"framework","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"e80f7c67e269fae524f6","678":"dd4791a6a9db345f9dae","774":"d6eb0b5704ee673bdbf0","883":"96adec5882cd350ea518"}[chunkId] + ".js";
};